
import {Component, OnInit, ViewContainerRef} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {ToastsManager} from 'ng2-toastr/ng2-toastr';
import {Router} from '@angular/router';
import {PaginationInstance} from 'ngx-pagination';
import {Observable} from 'rxjs/Rx';
import {TokenListService} from '../token-list.service';
import {MstUnitService} from '../../configuration/mst-unit/mst-unit.service';
import {MstStaffService} from '../../configuration/mst-staff/mst-staff.service';
import {TrnAdmissionService} from '../../configuration/trn-admission/trn-admission.service';
import {Aarogyam, Iilds, Karad, Medikal, MK, Nepal, Tata, Turkish} from '../../shared/my-constants';

@Component({
  selector: 'app-ipd-token-list',
  templateUrl: './ipd-token-list.component.html',
  styleUrls: ['./ipd-token-list.component.css']
})
export class IpdTokenListComponent implements OnInit {
    public date: Date = new Date();
    staffid: Number = 0;
    dept: String = null;
    currentUser: any;
    multiplesearch: any = [];
    mstUnit: any;
    LoginForm: FormGroup;
    loading: boolean;
    mstTokenList: Array<any> = [];
    mstCabin: any;
    userDept: any = {};
    unitid: any;
    unitName: any;
    currentUserdetails: any;
    iilds: Boolean = Iilds;
    nepal: Boolean = Nepal;
    tata: Boolean = Tata;
    aarogyam: Boolean = Aarogyam;
    medikal: Boolean = Medikal;
    turkish: Boolean = Turkish;
    mk: Boolean = MK;
    karad: Boolean = Karad;

    departments: any = [{'department_id': 0, 'department_name': 'Oncology'}, {
        'department_id': 1,
        'department_name': 'Others'
    }];

    mstUnitList: Array<any> = [];
    mstDepartmentList: Array<any> = [];
    departmentList: Array<any> = [];
    subDepartmentList: Array<any> = [];
    selectedDepartmentList = [];
    selectedSubDepartmentList = [];
    mstSubDepartmentList: Array<any> = [];
    mstSpecialityList: Array<any> = [];
    mstDoctorList: Array<any> = [];
    doctorList: Array<any> = [];
    selectedDoctorList: Array<any> = [];
    mstCabinList: Array<any> = [];
    selectedUnit: any = {};
    specialityList: Array<any> = [];
    selectedSpecialityList: Array<any> = [];
    cabinList: Array<any> = [];
    selectedCabinList: Array<any> = [];
    // departmentWiseSearch:Boolean= false;
    // specialitySearch:Boolean= false;
    // cabintWiseSearch:Boolean= false;
    selectedToken: any = {};
    private timerInterval;
    public config: PaginationInstance = {
        id: 'advanced',
        itemsPerPage: 20,
        currentPage: 1,
        totalItems: 1
    };

    constructor(private fb: FormBuilder, private tokenListService: TokenListService, private router: Router,
                public toastr: ToastsManager, vcr: ViewContainerRef,
                private mstUnitService: MstUnitService,
                private mstStaffService: MstStaffService,
                private trnAdmissionService:TrnAdmissionService,
                // private mstDepartmentService: MstDepartmentService,
                // private mstSubDepartmentService: MstSubDepartmentService,
                // private mstCabinService: MstCabinService,
                // private mstSpecialityService: MstSpecialityService
    ) {
        // this.toastr.setRootViewContainerRef(vcr);
        // Observable.interval(10000)
        //     .map((x) => x + 1)
        //     .subscribe((x) => {
        //         this.getPage(1);
        //         this.date = new Date();
        //     });
    }

    ngOnInit() {
        this.currentUserdetails = JSON.parse(sessionStorage.getItem('userdetail'));
        this.currentUser = JSON.parse(sessionStorage.getItem('userdetail'));
        this.unitid = JSON.parse(sessionStorage.getItem('unitId'));
        this.unitName = sessionStorage.getItem('unitName');
        this.selectedUnit = {unitId: this.unitid, unitName: this.unitName};
        let event: any = {};
        event.key = null;
        event.key = '';
        this.multiplesearch.departmentWiseSearch = false;
        this.multiplesearch.specialitySearch = false;
        this.multiplesearch.cabintWiseSearch = false;
        this.multiplesearch.showPatientQueue = true;
        this.multiplesearch.showPatientCall = true;
        this.multiplesearch.nonofabove = false;
        this.multiplesearch.video = true;
        this.multiplesearch.showScrollMessage = false;
        this.multiplesearch.scrollMessage = '';
        this.getUnitDetailsById(this.unitid);
    //    this.getPage(1);
      //  this.getUnitList(event);
    }

    getPage(page: number) {
        this.mstTokenList = [];
            this.trnAdmissionService.getAllAdmissionRecordService(page, this.config.itemsPerPage, '', '', '')
                .then(resp1 => {
                    console.log("ipd");
                     console.log(resp1);
                    this.config.currentPage = page;
                    this.config.totalItems = resp1.totalElements;
                    this.loading = false;
                    this.mstTokenList = resp1.content;
                    console.log(this.config.currentPage);
                   this.timerInterval=  setTimeout(() => {
                       if(this.config.currentPage === resp1.totalPages)
                        {
                            this.getPage(1);
                        }
                        else
                        {
                            this.config.currentPage = this.config.currentPage+1;
                            this.getPage(this.config.currentPage);
                        }
                    },5000);
                });

    }


    getUnitDetailsById(id: any) {
        this.mstUnitService.getRecordService(id)
            .then(resp => {
                this.mstUnit = resp;
                this.getPage(1);
            });
    }

    ngOnDestroy() {
        // Will clear when component is destroyed e.g. route is navigated away from.
        clearInterval(this.timerInterval);
    }

}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/token-list/ipd-token-list/ipd-token-list.component.ts